<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form"   :model="formParameter" :inline="true" label-width="120px">
        
        <el-row>
          <el-col :span="24">
            <el-divider content-position="left">
              {{ this.$parent.Subflag }} {{ (this.parameter.type == 1 ? '技术文档' : (this.parameter.type == 2 ? '授课视频' : (
    this.parameter.type == 3 ? '课堂笔记' : (this.parameter.type == 4 ? '代码附件' : '学习总结')))) }} 列表
            </el-divider>

            <!-- 操作模块 -->
            <el-col v-if="parameter.type == 9">
              <h4>点击显示</h4>
              <el-collapse v-model="activeNames">

                <el-collapse-item v-for="(item, index) in options"
                  :title="(index + 1) + '#.       【'+ (item.title) +'】 '+ (item.name ? item.name :'') + '    ,          总结时间 :' + new Date(item.subtime).format('yyyy-MM-dd')"
                  :name="index" :key="index">
                  <el-divider content-position="left">总结正文</el-divider>
                  <div v-html="item.content"></div>
                </el-collapse-item>

              </el-collapse>
            </el-col>

            <el-row v-for="(itm, index) in options" v-bind:key="index" v-else>
              <el-col :span="2">
                <el-input readonly :value="index + 1"></el-input>
              </el-col>
              <el-col :span="17">
                <el-form-item>
                  <el-input readonly v-model="itm.title"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="3" v-if="parameter.type<3">
                <a :href="itm.url" target="_blank">
                  <el-button type="primary">打开URL</el-button>
                </a>
              </el-col>
              <el-col :span="2"  v-if="parameter.type>2 && parameter.type!=9" >
                     <el-link v-if="itm.type==4"   @click="doShow(itm)" type="primary" >下载</el-link>
                     <div v-else-if="itm.remarks && itm.remarks.indexOf('https')>=10 && itm.remarks.indexOf('https')<45" v-html="itm.remarks"></div>
                     <el-link v-else @click="doShow(itm)" type="primary" > 详情 </el-link>
              </el-col>

            </el-row>
          </el-col>

        </el-row>
      </el-form>
      <showvdo ref="showvdo"></showvdo>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/edu/subject/subject.js";
import apiVdo from '@/api/edu/videoes/videoes.js'
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import showvdo from "@/views/study/videoes/edit.vue";
import caches from "util/caches.js";
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
    wangEdit,
    showvdo
  },
  data() {
    return {
      activeNames: ['1'],
      urlNum: 1,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      options: [],
      urlList: []
    };
  },
  methods: {
    addSelectItem() {
      this.options.push({ k: "", v: "" });

    },
    removeSelectItem() {
      let rc = this.options.pop();
      this.checkList.splice(this.checkList.indexOf(rc), 1);
    }, doShow(itm) {

      if(this.parameter.type ==3){
        this.$refs.showvdo.open({ id: itm.id,type:this.parameter.type}, true)
        this.popupLoading = false
      }else{
        let tokenVal = caches.token.get();
        console.log("tokenVal",tokenVal)
        apiVdo.downCodes(null, { url:itm.url },{ token: tokenVal })
      }
     

    },
    //打开弹框
    open(parameter, title, disabled, size) {

      this.parameter = parameter;
      this.options = []
      this.disabled = disabled;
      this.$refs.popup.open(title, 1280);

      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.options = [];
      this.disabled = false;
      this.$refs.popup.close();
    },

    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
          type: this.parameter.type
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          if (this.parameter.type != 9) {
            this.options.push(...response.data.videoes)
          } else {
            this.options.push(...response.data.feedbacks)
          }

          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
        this.formParameter.level = this.parameter.level ? this.parameter.level : 1
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";


</style>